__webpack_require__.p = "https://auth.stage.veeva.link/";